import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/lib/api'

type AdminWorkspace = {
  id: string
  name: string
  createdAt: string
  memberCount: number
  skillCount: number
}

export default function AdminWorkspacesPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['admin', 'workspaces'],
    queryFn: async () =>
      (await apiClient.get<{ data: AdminWorkspace[] }>('/api/v1/admin/workspaces')).data,
  })

  if (isLoading) return <p className="text-sm text-neutral-500">Loading…</p>

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold">Workspaces</h1>
      <div className="rounded border bg-white overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-left text-xs uppercase text-neutral-500 border-b">
            <tr>
              <th className="px-3 py-2">Name</th>
              <th className="px-3 py-2">Members</th>
              <th className="px-3 py-2">Skills</th>
              <th className="px-3 py-2">Created</th>
            </tr>
          </thead>
          <tbody>
            {(data?.data ?? []).map((w) => (
              <tr key={w.id} className="border-b">
                <td className="px-3 py-2">{w.name}</td>
                <td className="px-3 py-2">{w.memberCount}</td>
                <td className="px-3 py-2">{w.skillCount}</td>
                <td className="px-3 py-2 text-neutral-500">
                  {new Date(w.createdAt).toLocaleDateString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
